import type { Appointment, Professional, SlotsResponse } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export const TZ = 'America/Sao_Paulo'; // fuso da unidade (única unidade por enquanto)

export const professionalsQuery = queryOptions({
  queryKey: ['scheduling', 'professionals'], queryFn: () => api<Professional[]>('/scheduling/professionals'), staleTime: 300_000,
});
export const slotsQuery = (date: string, professionalId?: string) => queryOptions({
  queryKey: ['scheduling', 'slots', date, professionalId ?? 'all'],
  queryFn: () => api<SlotsResponse>(`/scheduling/slots?data=${date}${professionalId ? `&profissional=${professionalId}` : ''}`),
  staleTime: 15_000,
});
/** Dia local → intervalo UTC (São Paulo não tem horário de verão desde 2019: −03:00 fixo). */
export const dayRange = (date: string) => ({ from: `${date}T00:00:00-03:00`, to: `${date}T23:59:59-03:00` });
export const calendarQuery = (date: string) => queryOptions({
  queryKey: ['scheduling', 'calendar', date],
  queryFn: () => { const r = dayRange(date); return api<Appointment[]>(`/scheduling/calendar?de=${encodeURIComponent(r.from)}&ate=${encodeURIComponent(r.to)}`); },
  staleTime: 15_000,
});
export const contactAppointmentsQuery = (contactId: string) => queryOptions({
  queryKey: ['scheduling', 'by-contact', contactId], queryFn: () => api<Appointment[]>(`/scheduling/appointments/by-contact/${contactId}`),
});

export const todayLocal = () => new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date());
export const addDays = (date: string, n: number) => {
  const d = new Date(`${date}T12:00:00-03:00`);
  d.setUTCDate(d.getUTCDate() + n);
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(d);
};
export const hhmm = (iso: string) => new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: TZ }).format(new Date(iso));
/** Minutos desde a meia-noite local. */
export const localMinutes = (iso: string) => {
  const [h, m] = hhmm(iso).split(':').map(Number);
  return h! * 60 + m!;
};
export const longDate = (date: string) => new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: TZ })
  .format(new Date(`${date}T12:00:00-03:00`));

export const STATUS_STYLE: Record<string, { label: string; box: string }> = {
  scheduled: { label: 'Agendada', box: 'border-info/40 bg-info-soft text-fg' },
  confirmed: { label: 'Confirmada', box: 'border-success/50 bg-success-soft text-fg' },
  checked_in: { label: 'Chegou', box: 'border-primary/60 bg-primary-soft text-fg' },
  completed: { label: 'Concluída', box: 'border-border bg-surface-muted text-fg-muted' },
  no_show: { label: 'Faltou', box: 'border-danger/40 bg-danger-soft text-fg-muted line-through' },
  cancelled: { label: 'Cancelada', box: 'border-dashed border-border bg-surface text-fg-subtle line-through' },
};
export const KIND_LABEL: Record<string, string> = { evaluation: 'Avaliação', consultation: 'Consulta', follow_up: 'Retorno', block: 'Bloqueio', surgery: 'Cirurgia' };
